export const myMixins= {
    data() {
        return {
          weiboList:[
            {
              img:'http://hfy-img.xzyunchuang.com/df88eb825eb7aa91abb665d8e5789d5a',
              title:'铜山发布',
              jump:'https://weibo.com/tongshanfabu'
            },
            {
              img:'http://hfy-img.xzyunchuang.com/66f7d22c083a30844ad2e7af35fc2432',
              title:'徐州环保',
              jump:'http://e.weibo.com/u/3514775860'
            },
            {
              img:'http://hfy-img.xzyunchuang.com/abf0c0fae3fb720a87121dc2a629f6a4',
              title:'徐州妇联',
              jump:'http://weibo.com/u/3516606061 '
            },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/45db9f7cdf34dbe734daecb02636ea19',
            //   title:'徐州农委',
            //   jump:'http://weibo.com/u/2131188714'
            // },
            {
              img:'http://hfy-img.xzyunchuang.com/7c27cfac6a6cbaa585d1c3b5103684e1',
              title:'徐州编办',
              jump:'http://weibo.com/u/3536863112'
            },
            {
              img:'http://hfy-img.xzyunchuang.com/e76487451c3cb22173bc638dea0907a2',
              title:'徐州气象',
              jump:'http://weibo.com/u/2290863022'
            },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/aad4bcd503aeeaef66d2856949a4de08',
            //   title:'徐州审计',
            //   jump:'http://weibo.com/u/3515614862'
            // },
            {
              img:'http://hfy-img.xzyunchuang.com/e08b87913192e1203abf4d4fb8a1d658',
              title:'徐州残联',
              jump:'http://weibo.com/xuzhoucanlian'
            },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/8eaf296f7353c509703fbfa5dede7f7e',
            //   title:'徐州科协',
            //   jump:'http://weibo.com/u/3511887137'
            // },
            {
              img:'http://hfy-img.xzyunchuang.com/5bc5721fd3349d656384d85291871b4c',
              title:'红十字会',
              jump:'http://weibo.com/xuzhouhh83861577'
            },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/1c5d04e9bf171a1688013e4c3d67d907',
            //   title:'机关事务..',
            //   jump:'http://weibo.com/u/3512740894'
            // },
            {
              img:'http://hfy-img.xzyunchuang.com/3c330a9af2960650de5684119ac44cab',
              title:'徐州发布',
              jump:'http://weibo.com/xzfabu'
            },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/ecfc1fcbb3e3a662f537577666a9f673',
            //   title:'徐州民政',
            //   jump:'http://weibo.com/u/3536870004'
            // },
            {
              img:'http://hfy-img.xzyunchuang.com/8bfecc50fbb02cc421b682bde7d5f842',
              title:'共青团',
              jump:'http://e.weibo.com/u/2024119204'
            },
            {
              img:'http://hfy-img.xzyunchuang.com/49749ce90ebbd409a28c1b01b7c8394b',
              title:'疾病预防',
              jump:'http://e.weibo.com/u/3310445864'
            },
            {
              img:'http://hfy-img.xzyunchuang.com/f721196c9067b974769b8ea617c6a756',
              title:'云龙检察',
              jump:'http://weibo.com/yunlongjiancha'
            },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/8a725c9edfbf95da4448f169addea16c',
            //   title:'旅游局',
            //   jump:'http://weibo.com/xzta'
            // },
            // {
            //   img:'http://hfy-img.xzyunchuang.com/476a49b4db357585bb49f2a7291d6cbe',
            //   title:'开发区',
            //   jump:'http://weibo.com/u/2128705797'
            // },
            {
              img:'http://hfy-img.xzyunchuang.com/083fedbccfc9999e9b6f24e59ff9e250',
              title:'交巡警',
              jump:'http://weibo.com/xzjxj'
            },
            {
              img:'http://hfy-img.xzyunchuang.com/61e27ef52079fae93cc2b90945ac9222',
              title:'平安徐州',
              jump:'http://weibo.com/pinganxuzhou'
            },
    
          ]
        }
    },
}



// WEBPACK FOOTER //
// ./src/mixins/weibo.js